import React from 'react';
import c from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import DeviationDumbView from '@wix/da-shared-react/pkg/DeviationViews/Dumbo';
import PlayVideoIcon from '@wix/da-ds/pkg/Icons/24x24/PlayVideo';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PreviewThumb, { Props as PreviewThumbProps } from '../PreviewThumb';
import s from './MainThumb.scss';

interface Props extends PreviewThumbProps {
  item: PapiDeviation;
}

const MainThumb: React.FC<Props> = ({ item, className, ...props }) => (
  <PreviewThumb className={c(s['root'], className)} {...props}>
    {item.isVideo && (
      <PlayVideoIcon
        className={s['thumb-overlay-icon']}
        size={IconSize.MEDIUM}
        disableDefaultColors
      />
    )}
    <DeviationDumbView deviation={item} height={56} width={56} />
  </PreviewThumb>
);

MainThumb.displayName = 'MainThumb';

export default MainThumb;
